import { xget } from "../Fetchv2.js";
import { PGSchema } from "../schemas/pg.schema.js";

export class World {
	static async getCountries() {
		let response = await xget<{ countries: PGSchema.countries[] }>(`/countries`);
		return response;
	}

	static async getStates(country: PGSchema.countries["id"]) {
		let response = await xget<{ states: PGSchema.states[] }>(`/states`, { country });
		return response;
	}

	getCities(params: { id?: string; state?: string }) {
		return xget<{ cities: PGSchema.cities[] }>(`/cities`, params);
	}

	async getZip(city: string) {
		let response = await xget<{ zip: PGSchema.zip[] }>(`/zip`, { city });
		return response;
	}

	async getNeighborhood({ zip, city }: { zip?: string; city?: string } = {}) {
		let response = await xget<{ neighborhood: PGSchema.neighborhood[] }>(`/neighborhood`, { zip, city });
		return response;
	}
}
